import db from '@utils/db';
import { useI18n } from '@i18n/useI18n';
import {forwardRef, useEffect, useImperativeHandle, useRef, useState} from 'react';
import {LottieContainer} from './LottieContent.styled';
import Lottie from 'react-lottie-player'
import LottieLight from 'react-lottie-player/dist/LottiePlayerLight.modern';

interface IProps {
  animate: boolean,
  apear: boolean,
  resetBadge?:boolean,
  lottieObject: any,  
  level: string,
  textObject: any
}

export const LottieContent = forwardRef((props: IProps, ref) => {
  const i18n = useI18n();
  const [days, setDays] = useState(25)
  const [levelAni, setLevelAni] = useState({main:false, number:false})
  const [delay, setDelay] = useState(false)
  const [finishAnimation, setFinishAnimation] = useState(false)
  const [moveDelay, setMoveDelay] = useState(true)
  const [appear, setAppear] = useState(false)
  const [animation, setAnimation] = useState(null)
  const [anim, setAnim] = useState(null)
  const level = useRef(null)
  const frame = useRef(0)

  

  useImperativeHandle(ref, () => ({
    showBadge() {
      setAppear(true)
    },
    startAnimation() {
      StartAnimationFlow()
    },
    hideBadge() {
      setDelay(true)
    },
    changeLevel(l) {
      let animation = JSON.parse(JSON.stringify(props.textObject))
      setMoveDelay(true)
      frame.current = 149
      animation.animationData.assets[2].layers[0].t.d.k[0].s.t = l.toString()
      level.current = l
      setAnimation(animation)
    }
  }));

  // console.log(props.level)

  useEffect(() => {
      if(props.level !== level.current)
      {
        let animation = JSON.parse(JSON.stringify(props.textObject))
        animation.animationData.assets[2].layers[0].t.d.k[0].s.t = props.level
        let anim = JSON.parse(JSON.stringify(props.lottieObject))
        anim.animationData.assets[2].layers[0].t.d.k[0].s.t = " "
        level.current = props.level
        setAnimation(animation)
        setAnim(anim)
      }
  }, [props.level])


  const flowTimers = useRef<ReturnType<typeof setTimeout>[]>([])

  useEffect(() => {
    return () => flowTimers.current.forEach(t => clearTimeout(t))
  }, [])

  const StartAnimationFlow = () =>{
      flowTimers.current.forEach(t => clearTimeout(t))
      flowTimers.current = []
      setMoveDelay(false)
      flowTimers.current.push(setTimeout(() => {
        setFinishAnimation(true)
        flowTimers.current.push(setTimeout(() => {
          if(props.resetBadge)setDelay(true)
        }, 8000));
      }, 2400));
  }

  return (
    animation?<><LottieContainer animate={finishAnimation} apear={appear} hide={delay}>
    <Lottie animationData={anim.animationData} loop={false} play={!moveDelay} goTo={frame.current} rendererSettings={{preserveAspectRatio: 'xMidYMid slice'}} />
  </LottieContainer><LottieContainer animate={finishAnimation} apear={appear} hide={delay}>
    <Lottie animationData={animation.animationData} loop={false} play={!moveDelay} goTo={frame.current} rendererSettings={{preserveAspectRatio: 'xMidYMid slice'}} />
  </LottieContainer></>:null
  );
});

export default LottieContent;



